import styled from "styled-components";

export const FeaturesInner = styled.div`
display: flex;
flex-direction: row;
flex-wrap: wrap;
@media screen and (max-width: 1050px) {
    flex-direction: column;
    align-items: center;
 }
`
export const FeaturesLeft = styled.div`
width: 65%;
display: flex;
fleax-grow: 0;
flex-shrink: 0;
flex-direction: row;
flex-wrap: wrap;
column-gap: 25px;
row-gap: 25px;
@media screen and (max-width: 1050px) {
    width: 100%;
    column-gap: 0;
    justify-content: space-evenly;
 }
`

export const FeaturesRight = styled.div`
width: 30%;
display: flex;
fleax-grow: 0;
flex-shrink: 0;
flex-direction: column;
@media screen and (max-width: 1050px) {
    width: 100%;
 }
`